import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const CREATE_UNIT_RESERVATION_REFUND = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createUnitReservationRefund',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
      { name: 'reason', type: 'String', required: true },
      { name: 'bank_name', type: 'String', required: true },
      { name: 'bank_account_number', type: 'String', required: true },
      { name: 'bank_account_name', type: 'String', required: true },
      { name: 'project_name', type: 'String', required: true },
      { name: 'purchaser_name', type: 'String', required: true },
      { name: 'amount_minor', type: 'Int', required: true },
      { name: 'currency_code', type: 'String', required: true },
      { name: 'rejection_reason', type: 'String' },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'reason', value: 'reason' },
      { name: 'bank_name', value: 'bank_name' },
      { name: 'bank_account_number', value: 'bank_account_number' },
      { name: 'bank_account_name', value: 'bank_account_name' },
      { name: 'project_name', value: 'project_name' },
      { name: 'purchaser_name', value: 'purchaser_name' },
      { name: 'amount_minor', value: 'amount_minor' },
      { name: 'currency_code', value: 'currency_code' },
      { name: 'rejection_reason', value: 'rejection_reason' },
    ],
    fields: '{...UnitReservationRefundFields}',
    fragments: [Fragments.unitReservationRefundResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const UPDATE_UNIT_RESERVATION_REFUND = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'updateUnitReservationRefund',
    args: [
      { name: 'refund_id', type: 'String', required: true },
      { name: 'amount_minor', type: 'Int' },
      { name: 'currency_code', type: 'String' },
      { name: 'reason', type: 'String' },
      { name: 'bank_name', type: 'String' },
      { name: 'bank_account_number', type: 'String' },
      { name: 'bank_account_name', type: 'String' },
      { name: 'project_name', type: 'String' },
      { name: 'purchaser_name', type: 'String' },
      { name: 'rejection_reason', type: 'String' },
    ],
    argsMap: [
      { name: 'refund_id', value: 'refund_id' },
      { name: 'amount_minor', value: 'amount_minor' },
      { name: 'currency_code', value: 'currency_code' },
      { name: 'reason', value: 'reason' },
      { name: 'bank_name', value: 'bank_name' },
      { name: 'bank_account_number', value: 'bank_account_number' },
      { name: 'bank_account_name', value: 'bank_account_name' },
      { name: 'project_name', value: 'project_name' },
      { name: 'purchaser_name', value: 'purchaser_name' },
      { name: 'rejection_reason', value: 'rejection_reason' },
    ],
    fields: '{...UnitReservationRefundFields}',
    fragments: [Fragments.unitReservationRefundResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const UPDATE_UNIT_RESERVATION_REFUND_STATUS = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'updateUnitReservationRefundStatus',
    args: [
      { name: 'refund_id', type: 'String', required: true },
      { name: 'status', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'refund_id', value: 'refund_id' },
      { name: 'status', value: 'status' },
    ],
    fields: '{...UnitReservationRefundFields}',
    fragments: [Fragments.unitReservationRefundResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
